"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createBmi = createBmi;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
function createBmi({ formatNumber }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.bmi);
    if (event === undefined) {
        return { value: "-" };
    }
    return {
        value: formatNumber(event.value),
        timestamp: event.timestamp,
        origin: event.origin
    };
}
